import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { UserService } from '../../services/user.service';

/**
 * Provides a view of an audio product.
 */
@Component({
	selector: 'doc-audio-view',
	templateUrl: './doc-audio-view.component.html',
	styleUrl: './doc-audio-view.component.css'
})
export class DocAudioViewComponent implements OnInit {

	@Input() product!: any;
	@Input() viewerURL: SafeResourceUrl | undefined;
	@Input() viewerOverviewURL: SafeResourceUrl | undefined;

	LOCALIZATION: any;

	constructor(
		private userService: UserService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	ngOnInit(): void {
		this.loadDocument();
	}

	private loadDocument(): void {
		// Placeholder. Nothing needs to be done currently.
	}
}
